import React from "react";
import "./Home.css";
import Product from "./Product";

function Home() {
  return (
    <div className="home">
      <div className="home__container">
        <img
          className="home__image"
          src="https://images-eu.ssl-images-amazon.com/images/G/02/digital/video/merch2016/Hero/Covid19/Generic/GWBleedingHero_ENG_COVIDUPDATE__XSite_1500x600_PV_en-GB._CB428684220_.jpg"
          alt=""
        />

        <div className="home__row">
          <Product
            id="1111111"
            title="Technics SL-1200 MK7 - combined Technics‘ traditional analogue technology and advanced digital technology"
            price={295}
            rating={4}
            image="https://media.tenor.com/images/fc9c29ac159e774606ce18143f2de87a/tenor.gif"
          />
          <Product
            id="2222222"
            title="Anti Theft Business Laptop Backpack with USB Charging Port Fits 15.6 inch Laptop."
            price={38.99}
            rating={3}
            image="https://images-na.ssl-images-amazon.com/images/I/71EpOxCxgPL._AC_SL1292_.jpg"
          />
        </div>

        <div className="home__row">
          <Product
            id="3333333"
            title="Victorinox Swiss Army Knife - 130 years of Master Craftsmanship. Also great to open wine bottles."
            price={35.99}
            rating={3}
            image="https://assets.victorinox.com/mediahub/33638/640Wx560H/SAK_1_3613__S1.jpg"
          />
          <Product
            id="4444444"
            title="Hitchhiker's Guide To The Galaxy. Knowing where one's towel is and it has the words 'DON'T PANIC' in large, friendly letters on the cover."
            price={29.99}
            rating={5}
            image="https://panmacmillanapi.blob.core.windows.net/pmapi/e0aeab21-67a1-43f9-bed7-08d59a3b1f0c/editions/51d91988-fa7b-4e64-5932-08d5cb8be8bd/original_400_600.jpg"
          />
          <Product
            id="5555555"
            title="Chemex Coffee Pot. 6 cup pour over glass coffeemaker. Time for Zen coffee... then get back coding."
            price={29.99}
            rating={3}
            image="https://store.chemexcoffeemaker.com/media/catalog/product/c/h/chemex-classic-10cup-detail_1.png"
          />
        </div>

        <div className="home__row">
          <Product
            id="6666666"
            title="Allwood Solvalla | 172 SQF Studio Cabin Kit, Garden House. Code in peace, in nature."
            price={4995}
            rating={4}
            image="https://i.pinimg.com/736x/cb/5d/94/cb5d94e87058dff855466fb187161bf3.jpg"
          />

          <Product
            id="7777777"
            title="MacBook Pro 15-inch Core i7 2.7GHz Pro 455 2GB (Silver, Late 2016)"
            price={2100.0}
            rating={4}
            image="https://cdn.shopify.com/s/files/1/0306/8677/products/2FRONT_1024_683_b11659df-7f34-4baf-b489-12498299c776.jpg?v=1550135822"
          />
        </div>
      </div>
    </div>
  );
}

export default Home;
